import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

type SearchType = "user" | "post";

export const searchApi: any = createApi({
  reducerPath: "searchApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["search"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getSearchData: builder.query<
      any,
      {
        q: string;
        type: SearchType;
        limit?: number;
        offset?: number;
        city?: string;
      }
    >({
      query: ({ q, type, limit = 10, offset = 0, city }) => ({
        url: `/khoj`,
        method: "GET",
        params: {
          q: q,
          type: type,
          limit: limit,
          offset: offset,
          city: city,
        },
      }),
    }),
    addSearchHistory: builder.mutation<
      any,
      { query: string; type: SearchType }
    >({
      query: ({ query, type }) => ({
        url: `/khoj`,
        method: "POST",
        data: { query, type },
      }),
    }),
    getSearchHistoryData: builder.query<any, void>({
      query: () => ({
        url: `/khoj/history`,
        method: "GET",
      }),
    }),
    getCompanySearchData: builder.query<
      any,
      { q: string; limit?: number; offset?: number }
    >({
      query: ({ q, limit = 10, offset = 0 }) => ({
        url: `/khoj/company?q=${q}&limit=${limit}&offset=${offset}`,
        method: "GET",
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useGetSearchDataQuery,
  useGetSearchHistoryDataQuery,
  useAddSearchHistoryMutation,
  useGetCompanySearchDataQuery,
} = searchApi;
